<template>
  <div class="bottom-cta">
    <h1>Boost your links today</h1>
    <BaseButton mode="btn-blue cta-button" title="Get Started" />
  </div>
</template>

<style scoped>
.bottom-cta {
  text-align: center;
  background: url(../../assets/images/bg-boost-desktop.svg);
  background-color: hsl(257, 27%, 26%);
  padding: 2.5rem;
  color: white;
}
</style>